export default () => ({
  el: undefined,
  form: undefined,
  gridId: undefined,
  endpoint: undefined,
  deleteKeys: undefined,
  init() {
    mrp.log(`RxDataGridDelete init`);
    this.el = this.$el;
    this.form = this.$refs.form;
    this.deleteKeys = this.$refs.deleteKeys;
    this.gridId = this.el.getAttribute("data-grid-id");
    this.endpoint = this.el.getAttribute("data-delete-endpoint");
  },
  delete() {
    let arr = [];
    const records = document.querySelectorAll(
      `[name='${this.gridId}-delete-record']`
    );
    for (let i = 0; i < records.length; i++) {
      if (records[i].checked) {
        arr.push(records[i].value);
      }
    }
    this.deleteKeys.value = JSON.stringify(arr);
    const sort = sessionStorage.getItem(`${this.gridId}-sort`) ?? "";
    const filter = sessionStorage.getItem(`${this.gridId}-filter`) ?? "";
    const context = sessionStorage.getItem(`${this.gridId}-context`) ?? "";
    let page = sessionStorage.getItem(`${this.gridId}-page`) ?? "1";
    if (page.trim() === "") {
      page = "1";
    }
    const path = `${this.endpoint}/${page}?focus=${this.gridId}-execute-filters&${filter}&${sort}&${context}`;
    this.form.setAttribute("hx-delete", path);
    htmx.process(this.form);
    htmx.trigger(this.form, "submit", {});
  },
});
